/* eslint-disable no-nested-ternary */
import styled from 'styled-components';
import { Refresh } from 'ui/icons';
import { Progress } from 'ui/progress';
import { BUTTON_VARIANTS, IconButton } from 'ui/button';
import { CircleSpinner } from 'ui/spinner';
import { Caption, Label, body2, spacing } from 'ui/theme';
import { CampaignState } from 'modules/domains/campaign';
import { useCampaignContext } from '../../context';
import { useQuerySendProgress } from '../../hooks/useQuerySendProgress';
import { LightText } from '../Sections/Sections.styled';
import { getLastUpdated, getPercentage, getSafeLocaleString } from './SendProgressBar.utils';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin: ${spacing.doubleHalf} 0;
  gap: ${spacing.fiveEights};
`;

const ContentRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const StyledLabel = styled(Label)`
  margin: 0;
`;

export const SendProgressBar = () => {
  const {
    campaign: { id, campaignState },
  } = useCampaignContext();
  const {
    sendProgress: { size, sent } = {},
    hasError,
    isLoading,
    dataUpdatedAt,
    refetch,
  } = useQuerySendProgress(id);

  const percentage = getPercentage(sent, size);
  const lastUpdated = getLastUpdated(dataUpdatedAt);
  const label = campaignState === CampaignState.Running ? 'Sending...' : 'Sent';
  const sentInfoText = `${percentage}% - ${getSafeLocaleString(sent)} of ${getSafeLocaleString(
    size,
  )} sent`;

  return (
    <Container>
      <ContentRow>
        <StyledLabel>{label}</StyledLabel>

        <IconButton
          variant={BUTTON_VARIANTS.GHOST}
          isDisabled={isLoading}
          isLoading={isLoading}
          onClick={() => {
            refetch();
          }}
        >
          <Refresh />
        </IconButton>
      </ContentRow>
      <Progress value={percentage} />
      <ContentRow>
        <Caption>
          {isLoading ? (
            <CircleSpinner size={body2.fontSize} />
          ) : hasError ? (
            <LightText>Could not fetch send progress</LightText>
          ) : (
            sentInfoText
          )}
        </Caption>
        <Caption>Last updated {lastUpdated}</Caption>
      </ContentRow>
    </Container>
  );
};
